import { Point } from "@cartographerio/geometry";
import {
  formatTimestamp,
  ProjectId,
  SurveyStatus,
  TeamId,
  Timestamp,
  utc,
  WorkspaceRef,
  yyyymmdd,
} from "@cartographerio/types";
import { SortOrder } from "../params";

export type SurveySearchKey =
  | "workspace"
  | "description"
  | "status"
  | "surveyor"
  | "timestamp"
  | "created"
  | "updated";

export interface SurveySearchOptionsV2 {
  workspace?: WorkspaceRef | null;
  q: string;
  from: Timestamp;
  to: Timestamp;
  sw: Point;
  ne: Point;
  status: SurveyStatus;
  order: SortOrder<SurveySearchKey>;
  skip: number;
  limit: number;
  format: "json" | "xslx" | "csv";
}

export interface SurveySearchOptionsV3 {
  project?: ProjectId | null;
  team?: TeamId | null;
  q: string;
  from: Timestamp;
  to: Timestamp;
  sw: Point;
  ne: Point;
  status: SurveyStatus;
  order: SortOrder<SurveySearchKey>;
  skip: number;
  limit: number;
  format: "json" | "xslx" | "csv";
}

export function formatTimestampParam(timestamp: Timestamp): string {
  return formatTimestamp(timestamp, { timeZone: utc, format: yyyymmdd });
}

export function formatPointParam(point: Point): string {
  return `${point.coordinates[1]},${point.coordinates[0]}`;
}
